import React, { useState, useMemo, useEffect } from "react";
import "./Modal.css";
import config from "../../config";
import { debounce } from "lodash";

import { CircularProgress, TableRow, TableBody, Switch, TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Delete } from "@material-ui/icons";
import Tooltip from '@material-ui/core/Tooltip';

// styles
import useStyles from "../login/styles";

const ModalGroupType = ({ isOpen, closeModal, partnerId, origin, newGroup, minOfPersons, onFinish }) => {
    var classes = useStyles();
    const handleContainerClick = (e) => e.stopPropagation();
    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [isLoading, setIsLoading] = useState(true);
    const [secondaryPartnerName, setSecondaryPartnerName] = useState([]);
    const [tittle, setTittle] = useState("");
    const [message, setMessage] = useState("");
    const [modifiedAll, setModifiedAll] = useState(false);
    const [step, setStep] = useState(1);
    const [isPrincipal, setIsPrincipal] = useState(false);
    const [allPartnersByGroupData, setAllPartnersByGroupData] = useState([]);
    const [allPartnersInividualData, setAllPartnersInividualData] = useState([]);
    const [partnerPrincipalName, setPartnerPrincipalName] = useState("");
    const [partnerPrincipalId, SetPartnerPrincipalId] = useState(0);
    const [isLoadingStep2, setIsLoadingStep2] = useState(true);
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [autocompleteTwoKey, setAutocompleTwoteKey] = useState(0);
    const [isLoadingUpdatePartner, setIsLoadingUpdatePartner] = useState(false);
    const [secondaryPartners, setSecondaryPartners] = useState([]);

    const fetchVerify = async () => {
        fetch(baseUrl + "verifyGroupType/" + partnerId,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            }).then(response => response.json())
            .then(data => {
                if (data.status == "Ok") {
                    setTittle("Cambiando de " + origin + " a " + newGroup);
                    if (data.content == "Individual") {
                        setMessage("Debes juntar un mínimo de " + minOfPersons + " personas");
                    } else {
                        setMessage("Este socio está en grupo con las siguientes personas:");
                        setModifiedAll(data.modifiedAll);
                        setSecondaryPartnerName(data.content);
                    }
                } else {
                    setTittle("No se encontró información del socio");
                }
            }).catch(error => null);

        setIsLoading(false);
    }

    useEffect(() => {
        fetchVerify();
    }, []);

    const fetchPartnersByGroup = async () => {
        const body = {
            groupName: newGroup
        };

        fetch(config.config[0].baseUrl + 'searchPartnerWithSameGroup',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(body)
            }
        ).then((res) => res.json())
            .then((data) => {
                if (data.status == "Ok") {
                    setAllPartnersByGroupData(data.content);
                }
            }).catch(error => null);

        setIsLoadingStep2(false);
    }

    const onYesButton = async e => {
        e.preventDefault();

        if (origin === "Individual" || origin === "individual") {
            fetchPartnersByGroup();
            setStep(2);
        } else {
            if (newGroup == "individual") {
                const body = {
                    partnerId: partnerId, groupType: newGroup, principalPartnerId: 0
                };

                const response = await fetch(baseUrl + "changeOnlyGroupType", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                    body: JSON.stringify(body)
                });

                const json = await response.json();
                if (json.message == "Ok") {
                    onFinish();
                    closeModal();
                } else {
                    closeModal();
                    onFinish();
                }
            } else {
                fetchPartnersByGroup();
                setStep(2);
            }
        }
    }

    const onNoButton = async e => {
        e.preventDefault();
        closeModal();
    }

    const handleChangePrincipal = event => {
        var value = event.target.checked;

        setIsPrincipal(value);
    };

    const delayedHandleChangeGetIndivualPartners = useMemo(() => {
        return debounce(search => {
            if (search != '') {
                const body = {
                    partnerId: partnerId
                };

                fetch(config.config[0].baseUrl + 'searchPartnerIndividual/' + search,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json', 'Content-Type': 'application/json',
                            'Authorization': localStorage.getItem("token")
                        },
                        body: JSON.stringify(body)
                    }
                ).then((res) => res.json())
                    .then((data) => {
                        if (data.status == "Ok") {
                            setAllPartnersInividualData(data.content);
                        }
                    });
            } else {
                setAllPartnersInividualData([]);
            }
        }, 700);
    }, []);

    const handleChangeSearchIndividualPartner = (e) => {
        delayedHandleChangeGetIndivualPartners(e.target.value.toLowerCase());
    }

    const onTagsChange = (event, values) => {
        if (values != null) {
            setPartnerPrincipalName(values.name);
            SetPartnerPrincipalId(values.partnerPrincipalId)
        } else {
            setPartnerPrincipalName("");
            SetPartnerPrincipalId(0);
        }
    }

    const onTagsChangeTwo = (event, values) => {
        if (values != null) {
            var added = false;

            for (var i = 0; i < secondaryPartners.length; i++) {
                var itemI = secondaryPartners[i];

                if (itemI.id == values.partnerPrincipalId) {
                    added = true;
                    i = secondaryPartners.length;
                }
            }

            if (!added) {
                var item = {
                    "id": values.partnerPrincipalId,
                    "name": values.name,
                };

                var list = secondaryPartners;
                list.push(item);
                setSecondaryPartners(list);
            }
        }

        setAutocompleTwoteKey(autocompleteTwoKey + 1);
    }

    const onDelete = (id) => e => {
        e.preventDefault();
        var index = -1;

        secondaryPartners.map((item) => {
            if (item.id == id) {
                index = secondaryPartners.indexOf(item);
            }
        });

        if (index > -1) {
            var list = [];
            for (var i = 0; i < secondaryPartners.length; i++) {
                var item = secondaryPartners[i];
                if (index != i) {
                    list.push(item);
                }
            }
            setSecondaryPartners(list);
        }
    }

    const onSaveOtherGroup = async e => {
        e.preventDefault();

        setIsLoadingUpdatePartner(true);
        const body = {
            partnerId: partnerId, groupType: newGroup, principalPartnerId: partnerPrincipalId
        };

        const response = await fetch(baseUrl + "changeOnlyGroupType", {
            method: 'POST',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(body)
        });

        const json = await response.json();
        if (json.message == "Ok") {
            setIsLoadingUpdatePartner(false);
            onFinish();
            closeModal();
        } else {
            setIsLoadingUpdatePartner(false);
            onFinish();
            closeModal();
        }
    }

    const onSaveNewGroup = async e => {
        e.preventDefault();
        setIsLoadingUpdatePartner(true);
        var list = [];

        secondaryPartners.map((item) => {
            list.push(item.id);
        });

        const body = {
            groupType: newGroup, principalPartnerId: partnerId, secondaryPatrnes: list
        };

        const response = await fetch(baseUrl + "changeMaultipleGroupType", {
            method: 'POST',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(body)
        });

        const json = await response.json();
        if (json.message == "Ok") {
            setIsLoadingUpdatePartner(false);
            onFinish();
            closeModal();
        } else {
            setIsLoadingUpdatePartner(false);
            onFinish();
            closeModal();
        }
    }

    return <article className={`modal ${isOpen && "is-open"}`}
        onClick={closeModal}>
        <div className="modal-group" onClick={handleContainerClick}>
            {isLoading ? (
                <div className={classes.loginLoader} >
                    <CircularProgress size={26} />
                </div>
            ) : (
                <div>
                    <p style={{ fontSize: "20px", textAlign: "center" }}>{tittle}</p>

                    {step === 1 ? (
                        <>
                            <p style={{ fontSize: "16px", textAlign: "center" }}>{message}</p>
                            <TableBody>
                                {secondaryPartnerName.map((itemQ) => (
                                    <TableRow style={{ height: "20px" }}>
                                        <text>- {itemQ}</text>
                                    </TableRow>
                                ))}
                            </TableBody>

                            {modifiedAll ? (
                                <>
                                    <p style={{ fontSize: "16px", textAlign: "center" }}>Si cambias el grupo de esta persona, los socios anteriores también se verán afectados.</p>
                                </>
                            ) : (
                                <>
                                    {origin == "Individual" ? (
                                        <></>
                                    ) : (
                                        <p style={{ fontSize: "16px", textAlign: "center" }}>Si cambias el grupo de esta persona, los socios anteriores no se verán afectados.</p>
                                    )}
                                </>
                            )}
                            <p style={{ fontSize: "16px", textAlign: "center" }}>¿Quieres continuar con el cambio?</p>

                            <div className={classes.rowButtons}>
                                <button
                                    className={classes.buttonYes}
                                    onClick={onYesButton}
                                >SI</button>

                                <button
                                    className={classes.buttonNo}
                                    onClick={onNoButton}
                                >NO</button>
                            </div>
                        </>
                    ) : (
                        <>
                            {isLoadingStep2 ? (
                                <div className={classes.loginLoader} style={{ margin: "auto", textAlign: "center" }}>
                                    <CircularProgress size={26} />
                                </div>
                            ) : (
                                <>
                                    <div style={{ display: "flex" }}>
                                        <p style={{ fontSize: "16px", textAlign: "center" }}>¿Agregarás más socios junto a esta persona?</p>

                                        <div className={classes.divSwitch}>
                                            <p style={{ fontSize: "16px", }}>No</p>
                                            <Switch
                                                checked={isPrincipal}
                                                onChange={handleChangePrincipal}
                                                inputProps={{ "aria-label": "controlled" }}
                                            />
                                            <p style={{ marginLeft: "16px", fontSize: "16px", }}>Si</p>
                                        </div>
                                    </div>

                                    {!isPrincipal ? (
                                        <>
                                            <div className={classes.searchDivFullWidthWithoutShadow} >
                                                <Autocomplete
                                                    key={autocompleteKey}
                                                    options={allPartnersByGroupData}
                                                    getOptionLabel={option => option.name}
                                                    onChange={onTagsChange}
                                                    className={classes.inputSearchFull}
                                                    openText={"Abrir"}
                                                    closeText={"Cerrar"}
                                                    clearText={"Limpiar"}
                                                    noOptionsText={"Sin resultados"}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            variant="standard"
                                                            placeholder={"Buscar socio"}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </div>

                                            {partnerPrincipalName != "" ? (
                                                <>
                                                    <p style={{ fontSize: "16px", textAlign: "center" }}>Ahora estarás en el mismo grupo que {partnerPrincipalName}.</p>
                                                </>
                                            ) : (
                                                <></>
                                            )}

                                            <div className={classes.rowButtons} style={{ marginTop: "24px" }}>
                                                {isLoadingUpdatePartner ? (
                                                    <div className={classes.loginLoader} style={{ margin: "auto", textAlign: "center" }}>
                                                        <CircularProgress size={26} />
                                                    </div>
                                                ) : (
                                                    <button
                                                        className={classes.buttonYes}
                                                        onClick={onSaveOtherGroup}
                                                    >GUARDAR</button>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <p style={{ fontSize: "16px", textAlign: "center" }}>Si las demás personas no están registradas. Ingresalas como socios individuales,
                                                una vez terminados vuelves a este proceso.</p>

                                            <div className={classes.searchDivFullWidthWithoutShadow} >
                                                <Autocomplete
                                                    key={autocompleteTwoKey}
                                                    options={allPartnersInividualData}
                                                    getOptionLabel={option => option.name}
                                                    onChange={onTagsChangeTwo}
                                                    className={classes.inputSearchFull}
                                                    openText={"Abrir"}
                                                    closeText={"Cerrar"}
                                                    clearText={"Limpiar"}
                                                    noOptionsText={"Sin resultados"}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            variant="standard"
                                                            placeholder={"Buscar socio"}
                                                            onChange={(event) => handleChangeSearchIndividualPartner(event)}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </div>

                                            <div style={{ marginTop: "24px" }}>
                                                {secondaryPartners.map((item) => (
                                                    <div style={{ display: "inline-block" }}>
                                                        <div className={classes.cardPartnerGroup} style={{ paddingLeft: "8px", paddingRight: "4px" }}>
                                                            <Tooltip title={item.name}>
                                                                <div className={classes.cardLabel} style={{ width: "140px", height: "45px", marginRight: "8px" }}>
                                                                    <p className={classes.tableCenterTextStyle} style={{
                                                                        display: "-webkit-box",
                                                                        overflow: "hidden", WebkitLineClamp: "1", WebkitBoxOrient: "vertical"
                                                                    }}>{item.name}</p>
                                                                </div>
                                                            </Tooltip>

                                                            <div className={classes.divActionButtonDisable} >
                                                                <Delete
                                                                    classes={{ root: classes.searchIcon }}
                                                                    onClick={onDelete(item.id)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className={classes.rowButtons} style={{ marginTop: "24px" }}>
                                                {isLoadingUpdatePartner ? (
                                                    <div className={classes.loginLoader} style={{ margin: "auto", textAlign: "center" }}>
                                                        <CircularProgress size={26} />
                                                    </div>
                                                ) : (
                                                    <>
                                                        {secondaryPartners.length < (minOfPersons - 1) ? (
                                                            <></>
                                                        ) : (
                                                            <button
                                                                className={classes.buttonYes}
                                                                onClick={onSaveNewGroup}
                                                            >GUARDAR</button>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </>
                            )}

                        </>
                    )}
                </div>
            )}
        </div>
    </article>
}

export default ModalGroupType;